import { Routes } from '@angular/router';
import { OrderSuccessPageComponent } from './pages/order-success-page/order-success-page.component';
import { MyOrdersPageComponent } from './pages/my-orders-page/my-orders-page.component';

export const routes: Routes = [
  { path: '', component: MyOrdersPageComponent },
  {
    path: ':orderId',
    children: [
      {
        path: '',
        redirectTo: 'success',
        pathMatch: 'full'
      },
      {
        path: 'success',
        component: OrderSuccessPageComponent
      }
    ]
  }
];
